import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import md5 from 'js-md5';
import utils from './utils';

import urls from './network/urls'


Vue.prototype.$md5 = md5
Vue.prototype.urls = urls

Vue.prototype.isEmpty = function(content){
  if (content === undefined || content == 'undefined' || content == null || content == 'null' || content == '' || content == ' ') {
    return true
  }
  return false
}


// 判断是否为移动端
function isMobile() {
  var userAgentInfo = navigator.userAgent;

  var mobileAgents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];

  var mobile_flag = false;

  //根据userAgent判断是否是手机
  for (var v = 0; v < mobileAgents.length; v++) {
      if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
          mobile_flag = true;
          break;
      }
  }
  var screen_width = window.screen.width;
  var screen_height = window.screen.height;

  //根据屏幕分辨率判断是否是手机
  if (screen_width < 500 && screen_height < 800) {
      mobile_flag = true;
  }

  return mobile_flag;
}

var mobile_flag = isMobile();

Vue.prototype.isMobile = mobile_flag


// // 在vue中调用 this.sendToClient('方法名?'.concat(JSON.stringify(params)))
// // 在安卓端可以通过拦截url获取到
// Vue.prototype.sendToClient = function (text) {
//   var iFrame;
//   iFrame = document.createElement('iframe');
//   iFrame.setAttribute('src', 'okgameclient:'.concat(text));
//   iFrame.setAttribute('style', 'display:none;');
//   iFrame.setAttribute('height', '0px');
//   iFrame.setAttribute('width', '0px');
//   iFrame.setAttribute('frameborder', '0');
//   document.body.appendChild(iFrame);
//   iFrame.parentNode.removeChild(iFrame);
//   iFrame = null;
// }
// Vue.prototype.callPay = function (url) {
//   console.log("start pay");
//   var iFrame;
//   iFrame = document.createElement('iframe')
//   iFrame.style.display ='none'
//   iFrame.setAttribute('src', url)
//   iFrame.setAttribute('style', 'display:none;');
//   iFrame.setAttribute('frameborder', '0');
//   iFrame.setAttribute('sandbox','allow-top-navigation allow-scripts')
//   document.body.appendChild(iFrame)
//   iFrame.parentNode.removeChild(iFrame);
//   iFrame = null;


//   // var iFrame;
//   // iFrame = document.createElement('iframe');
//   // iFrame.setAttribute('src', 'okgameclient:'.concat(text));
//   // iFrame.setAttribute('style', 'display:none;');
//   // iFrame.setAttribute('height', '0px');
//   // iFrame.setAttribute('width', '0px');
//   // iFrame.setAttribute('frameborder', '0');
//   // document.body.appendChild(iFrame);
//   // iFrame.parentNode.removeChild(iFrame);
//   // iFrame = null;
// }


// 在vue中调用 this.sendToClient('方法名?'.concat(JSON.stringify(params)))
// 在安卓端可以通过拦截url获取到
// Vue.prototype.sendToSuWanClient = function (text) {
//   var iFrame;
//   iFrame = document.createElement('iframe');
//   iFrame.setAttribute('src', 'suwanclient:'.concat(text));
//   iFrame.setAttribute('style', 'display:none;');
//   iFrame.setAttribute('height', '0px');
//   iFrame.setAttribute('width', '0px');
//   iFrame.setAttribute('frameborder', '0');
//   document.body.appendChild(iFrame);
//   iFrame.parentNode.removeChild(iFrame);
//   iFrame = null;
// }

// 接收安卓端发送的信息
// window.getUnreadMessages = function (unreadMessages) {
//   // let dataJson = JSON.parse(data);
//   store.commit("updateUnreadMessages", unreadMessages);
// }

// 接收安卓端发送的信息
// window.adCallback = function (adPlayInfo) {
//   // let dataJson = JSON.parse(data);
//   store.commit("rebateDoubleReceive", adPlayInfo);
// }

Vue.config.productionTip = false


let appObject = {
  el: '#app',
router,
store: store,
render: h => h(App)}

// let type = utils.getUrlKey("type")
// console.log('type', type);
// if (type === '') {

// }


/* eslint-disable no-new */
new Vue(appObject)


// WEBPACK FOOTER //
// ./src/main.js